// src/api/memory.js
import axios from './axiosInstance'; // ✅ ensures token is attached

export async function saveVectorMemory({ text, emotion, topic }) {
  const res = await axios.post('/api/memory/vector', { text, emotion, topic });
  return res.data;
}

export async function queryVectorMemory({ text, topK = 3, filter = {} }) {
  const res = await axios.post('/api/memory/vector/query', {
    text,
    topK,
    filter
  });
  return res.data.matches;
}
